<template>
  <!-- eslint-disable -->
  <div class='cookie-container-background'>
    <div class="cookie-content">
      <div class='section-header'>
        <h1>YouPaired Cookie Policy</h1>
      </div>
      <div class="cookie-section">
        <p>YouPaired utilizes certain technologies and solutions on its network of websites,
          mobile services,  software applications, or any other products offered by YouPiared
          (the “YouPaired Services”) to collect information and data that helps us enhance your
          online experience. Our Cookie Policy, refer to these technologies, which include cookies,
          pixels, web beacons, and gifs, collectively as “cookies.” This enables us to provide you
          with great knowledge, improve our product, and personalize advertisements and material while
          using the website and services from YouPaired.</p>
        <p>This policy explains the various types of cookies used on YouPaired platform, and services
          and how you can control them. We may change this Cookie Policy at any time: please take a
          look at the “last modified” legend at the top of this page to see when this Cookie Policy
          was last revised. Any changes in this Cookie Policy will become effective when we make the
          revised Cookie Policy available on or through the YouPaired Services.</p>
        <p>By agreeing to this Cookie Policy, or by using the YouPiared Services or any service of ours
          that links to this Cookie Policy, you expressly consent to the information handling practices,
          and storage and access of cookies as described in this policy. This cookie policy (“Cookie Policy”)
          describes the types of cookies we use on the Youpaired platform and services and our purposes 
          for using them.</p>
        <p>We hope that this policy helps you understand, and feel more confident about,
          our use of cookies. If you have any further queries, please contact us at 
          <a href="mailto:hello@youpaired.com">email</a>. For more information about our privacy practices,
          please review our privacy policy: <a href=" www.youpaired.com/privacy">Privacy policy</a>.
        </p>
        <h2>Your Consent</h2>
        <p>You agree with us and our third-party service providers to place cookies on your browser. For details
        of why we use cookies, the data they obtain from and about you, and your cookie decisions, 
        please read this Cookie Policy closely.</p>
       <h2>Withdraw Your Consent at Any Time</h2>
        <p>Please sign out if you do not want to recognize cookies from us or our third party 
          service providers in association with your use of the YouPaired platform and services, as 
          pointed out below. You can also use your browser settings to delete, block or disable cookies;
          see below for more information on how to do this. Please notice that disabling cookies will
          influence the operation of the platform and services on YouPaired and may inhibit you from
          accessing certain characteristics on the system and facilities on YouPaired.</p>
        <h2>What Is a Cookie?</h2>
        <p>A cookie is a small numbers and letters files which we save on your browser or your device's hard drive.
          Our policy will show cookies when user access the YouPaired platform and services,
          unless you have modified your settings in your web browser so that it will reject cookies.</p>
        <h2>Cookies Concepts</h2>
        <p>First and third party cookies: whether a cookie is' first' or' third' group belongs to the
          domain that places the cookie. First-party cookies are those set by a website/platform/services
          that the user visits at the time (e.g. servers located by http:/www.youpaired.com). 
          Third-party cookies are cookies that are installed by a domain other than that of the 
          website/services accessed by the user. If a user visits a website and another entity sets a
          cookie through that website, it would be a third-party cookie.Persistent cookies: 
          these cookies stay on the computer of a user for the duration of time stated in the cookie.
          They are activated every moment the user visits the page that generated that particular cookie</p>
        <h2>How to Delete and Block our Cookies</h2>
        <p>Most web browsers enables some control over most cookies through the browser settings.
          Indeed, if your web browser settings block all cookies (including essential cookies),
          then you might not be able to access all or some parts of the YouPaired platform and services.
          Unless you have modified your browser setting to deny cookies, our platform/app will release
          cookies as quickly as you enter the YouPaired platform and services.</p>
        <p>To Change your Cookie Settings: Generally found in the ‘options’ or ‘preferences’
          menu of your internet browser. In order to understand these settings, the following
          list may be helpful. Otherwise, use the ‘Help’ option in your web browser for more details.</p>
          <li><a href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies">
          Cookie settings in Internet Explorer</a></li>
          <li><a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences">
          Cookie settings in Firefox</a></li>
          <li><a href="https://support.google.com/chrome/answer/95647">
          Cookie settings in Chrome</a></li>
          <li><a href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471">
          Cookie settings in Safari</a></li>
        </div>
        <h2>Credit & Contact Information</h2>
        <p> If you have any questions about this Cookie Policy, please contact us via
        <a href="mailto:hello@youpaired.com">email</a>.
        </p>
        <h2>What Cookies Do We Use and Why?</h2>
        <p>Generally the Youpaired platform, products and services uses cookies to identify,
           and differentiate you from other YouPaired users. This enables us to provide you with a
           good experience and improve your user experience while you browse YouPaired platform and services.
           Cookies which we use on the YouPaired platform and services may be classified as follows.
           Some cookies can achieve more than one of these objectives.</p>
        <li>Strictly necessary</li>
        <li>Performance</li>
        <li>Functionality</li>
        <li>Targeting</li>
        <p>Cookies that are strictly necessary allow you to navigate around the YouPaired platform and
        services and use important features including secure areas. We can't provide the required services
        without these cookies. We use these strictly necessary cookies for the purpose of:</p>
        <li>Identifying you as logged into the YouPaired platform and services and for authenticating you.</li>
        <li> Make sure that you connect with the right service on the YouPaired platform and the services when we make any
        changes</li>
        <li> For security and information purposes.</li>
        <p>If you do not accept cookies we can not guarantee how YouPaired platform and services, or
          security on your YouPaired platform and services, will perform during your visit if you prevent
          cookies. You can still accept these cookies.</p>
        <p>Performance Cookies gather data on how the YouPaired platform and services are used,
          e.g. what pages you visit, journey and if you experience any errors. These cookies do not gather anything
          that could identify you, and are used exclusively to assist us to enhance the platform and
          services for our users, to gain insight into our users ' concerns and to evaluate our advertisement's efficiency.</p>
        <h2>Use of performance cookies:</h2>
        <p> Some of the performance cookies we use are controlled by third parties for us.</p>
        <li>Perform web analytics: Provide statistical data about the use of the YouPaired platform and services</li>
        <li>Tracking affiliates: provide recommendations to affiliates that one of our visitors has also visited their pages</li>
        <li>Procure data on the number of YouPaired users and services who have regarded a service or a product</li>
        <li>Help us to enhance the platform and services by measuring errors</li>
        <li>Test different designs, features and services for the YouPaired platform</li>
        <h2>Use of functionality cookies</h2>
        <p>Some of the functionality cookies we use are controlled by third parties for us.
          They are used to provide services or to remember settings to improve your visit.</p>
        <li>Remember yours applied settings, including design, font size, preferences,location, patterns and styles</li>
        <li>Remember if we have surveyed you whether you wanted to complete a survey</li>
        <li>YouPaired platform and services  remembers if you have engaged with a particular
          component or list and do not repeat it</li>
        <li>Show you when you’re signed in to the YouPiared platform and services</li>
        <li>To provide and display integrated audio and video material</li>
        <h2>Use of Targeted cookies</h2>
        <p>Targeting cookies are often used to track your visit to the YouPaired platform and services,
          as well as some other websites, apps and online services, along with the sites you  visited
          as well as the links you followed, enabling our platform to display targeted ads to you on or off
          the YouPaired platform and services. Some of these cookies are managed for us by third parties.</p>
        <p>We may use targeted cookies to: display targeted advertisements on or off YouPaired.
          To improve how we offer tailored advertisements, content  and material, and analyze the
          performance of ads campaign on the YouPaired platform.</p>
        <h2>More Information About Advertising, Analytics, and Service Providers</h2>
        <h3>YouPaired Opt-Out Options</h3>
        <p>Opting out of tracking may impact our ability to personalize ads and content tailored to your interests.
          This setting is tied to your cookies and, unless you are logged in to the YouPaired platform and services,
          will only be effective on the browser for which you have performed the opt-out. Please note that opting out
          does not opt you out of tracking by third-party cookies from third-party service providers, which have
          different opt out mechanisms, as described below.</p>
        <h3>Third Party Analytics and Service Providers</h3>
        <p>Facebook: Facebook Connect. For more information about what Facebook collects when you use Facebook
          buttons on the YouPaired platform and services, please see: <a href="https://www.facebook.com/about/privacy/">Data Policy.</a>
          Facebook Ads. For more information about what Facebook collects and your choices around Facebook Ads,
          please see: <a href="https://www.facebook.com/ads/ad_choices">AdChoices.</a></p>
        <p>Twitter: For more information about what Twitter collects when you use Twitter buttons on the YouPaired platform and
          services or visit the pages on the YouPaired platform and services that include these buttons,
          please see: the <a href="https://twitter.com/en/privacy">Twitter Privacy Policy.</a></p>
        <p>Google: For more information about what Google collects when you use Google buttons on the YouPaired platform and
          services or visit the pages on the YouPaired platform and services that include these buttons,
          please see the  <a href="https://policies.google.com/privacy/archive?hl=en">Google Privacy Policy.</a></p>
        <p>Linkedin: For more information about what LinkedIn collects when you use LinkedIn buttons on the YouPaired platform and
          services or visit the pages on the YouPaired platform and services that include these buttons,
          please see the  <a href="https://www.linkedin.com/legal/preview/privacy-policy">Linkedin Privacy Policy.</a></p>
        <p>Twitch: For more information about what LinkedIn collects when you use Twitch buttons on the YouPaired platform and
          services or visit the pages on the YouPaired platform and services that include these buttons,
          please see the <a href="https://www.twitch.tv/p/legal/privacy-policy/">Twitch Privacy Policy.</a></p>
        <p>Google Analytics: Google Analytics is a web analytics service provided by Google, Inc. (“Google”).
          Google uses cookies to help us analyze how users use the YouPaired platform and services.
          The information generated by the cookie about your use of the YouPaired platform and services
          (including your IP address) will be transmitted to and stored by Google on servers in the United States.
          In case of activation of the IP anonymization, Google will truncate/anonymize the last octet of the IP
          address for Member States of the European Union as well as for other parties to the Agreement on the
          European Economic Area. Only in exceptional cases, the full IP address is sent to and shortened by
          Google servers in the USA. On behalf of the YouPaired platform and services, Google will use this
          information for the purpose of evaluating your use of the YouPaired platform and services, compiling
          reports on your activity for us and third parties who help operate and provide services related to
          the YouPaired platform and services. Google will not associate your IP address with any other data
          held by Google. You may refuse the use of these cookies by selecting the appropriate settings on your
          browser as discussed in this notice. However, please note that if you do this, you may not be able
          to use the full functionality of the YouPaired platform and services. Furthermore, you can prevent
          Google’s collection and use of data (cookies and IP address) by downloading and installing a browser
          plug-in available under <a href="https://tools.google.com/dlpage/gaoptout">Google Analytics Opt-out Browser Add-on.</a> For more information about Google
          Analytics cookies, please see <a href="https://policies.google.com/privacy/archive?hl=en">Google Privacy Policy</a>
          and <a href="https://support.google.com/analytics/answer/6004245?hl=en">Google Analytics Help pages.</a></p>
        <p>Google has developed the Google Analytics opt-out browser add-on; if you want to opt out of
          Google Analytics, you can download and install the add-on for your web browser
        <a href="https://tools.google.com/dlpage/gaoptout">here.</a></p>
        <p>Please note that on the YouPaired platform and services, Google Analytics code is
          supplemented by “gat._anonymizeIp();” to ensure an
          anonymized collection of IP addresses (so called IP-masking).</p>
        <p>Ad Services and Other Service Providers. YouPaired works with third-party advertising service providers
          (“Ad Services Providers”) to display more relevant ads to users on the YouPaired platform and services
          and third-party sites. To provide more relevant advertising, these Ad Services Providers may use cookies.
          To learn more about their use of cookies and how you can opt out, please see the section below on
          self-regulatory advertising industry organizations.</p>
        <h2>More Information About YouPaired Ads and Personalization</h2>
        <p>Please see our Privacy Terms for more information about YouPaired Ads and Personalization on
          the YouPaired platform and services. More Information About Self-Regulatory Advertising Industry
          Organizations and Opt-Out Mechanisms</p>
        <p> If you have any questions about this Cookie Policy, please contact us via
        <a href="mailto:hello@youpaired.com">email</a>.</p>
      </div>
  </div>
  <!-- eslint-enable -->
</template>
<script>

export default {
  name: 'privacy',
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.cookie-container-background {
  max-width: 100%;
  justify-content: center;
  text-align: justify;
  margin: 2rem 1rem 5rem 1rem;
  font-size: 1rem;
}

.cookie-content {
  padding: 2rem;
  background-color: #FFFFFF;
  border-radius: 0.5rem;
}

.section-header {
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
}


h1 {
  font-weight: 600;
  text-transform: uppercase;
}
h2 {
  text-transform: uppercase;
}

p {
  margin-top: 1rem;
  line-height: 1.25rem;
}
</style>
